module.exports = __webpack_public_path__ + "static/media/lingxia.ef7a5976.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/lingxia.png
 ** module id = 460
 ** module chunks = 0
 **/